import React from 'react';
import {Typography} from '@material-ui/core';
import {AutoField} from 'components/forms/fields';
import fields from './fields';
import useFieldData from 'components/forms/hooks/useFieldData';
import {bootstrapOldForm} from '../AutoSection';
import {useFormPersistence} from 'components/forms/hooks';
import {useContext} from 'react';
import {FormState} from '../context';
import VesselEndSection from './VesselEndSection';

const OffshoreInstallation = props => {
    const {node} = useContext(FormState);
    const {state, updateState} = useFormPersistence(node);
    const [installationType, setInstallationType] = useFieldData(
        'offshore_installation_type'
    );

    const {schema, initialValues} = bootstrapOldForm(
        'Offshore Installation',
        fields
    );

    const updateInstallationType = event => {
        setInstallationType(event.target.value);
        updateState({
            ...state,
            offshore_installation_MODU_type: '',
            offshore_installation_MODU_propulsion_type: '',
            offshore_installation_FOI_type: '',
        });
    };

    return (
        <VesselEndSection
            {...props}
            {...{schema, initialValues}}
            shouldSave={true}
        >
            <Typography variant='h6' align='left'>
                Vessel
            </Typography>
            <AutoField
                field={fields.offshore_installation_type}
                name='offshore_installation_type'
                onChange={updateInstallationType}
            />

            {installationType === 'Mobile Offshore Drilling Unit' && [
                <AutoField
                    field={fields.offshore_installation_MODU_type}
                    name='offshore_installation_MODU_type'
                    key='modu-type'
                />,
                <AutoField
                    field={fields.offshore_installation_MODU_propulsion_type}
                    name='offshore_installation_MODU_propulsion_type'
                    key='modu-propulsion-type'
                />,
            ]}
            {installationType === 'Floating Offshore Installation' && (
                <AutoField
                    field={fields.offshore_installation_FOI_type}
                    name='offshore_installation_FOI_type'
                    key='foi-type'
                />
            )}
            {props.children}
        </VesselEndSection>
    );
};

export default OffshoreInstallation;
